import { GridDisplaySettings } from '@app/models';
import { UserGridType } from '@app/pcs/models/user-grid-type';
import { Action } from '@ngrx/store';

export enum UserGridConfigurationActionTypes {
  SetUserGridConfiguration = '[UserGridConfiguration] Set User Grid Configuration',
  ResetUserGridConfiguration = '[UserGridConfiguration] Reset User Grid Configuration',
  SaveUserGridConfigurationFail = '[UserGridConfiguration] Save User Grid Configuration Fail',
  UnsupportedUserGridType = '[UserGridConfiguration] Unsupported User Grid Type'
}

export class SetUserGridConfiguration implements Action {
  readonly type = UserGridConfigurationActionTypes.SetUserGridConfiguration;

  constructor(public payload: {userGridType: UserGridType; configuration: GridDisplaySettings}) {
  }
}

export class ResetUserGridConfiguration implements Action {
  readonly type = UserGridConfigurationActionTypes.ResetUserGridConfiguration;
}

export class SaveUserGridConfigurationFail implements Action {
  readonly type = UserGridConfigurationActionTypes.SaveUserGridConfigurationFail;

  constructor(public payload: Error) {}
}

export class UnsupportedUserGridType implements Action {
  readonly type = UserGridConfigurationActionTypes.UnsupportedUserGridType;
}

export type UserGridConfigurationActions =
  | SetUserGridConfiguration
  | ResetUserGridConfiguration
  | SaveUserGridConfigurationFail
  | UnsupportedUserGridType;
